import React from "react";
import { Dropdown } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import SendIcon from "../../assets/icons/send.svg2";
import TampleteIcon from "../../assets/icons/template_rec.svg2";
import SaveTampleteIcon from "../../assets/icons/icon_save-01.svg2";
import ScheduleIcon from "../../assets/icons/scheduling.svg2";
import MyModal from "../Common/MyModal.tsx";
import { SaveAsTemplateForm } from "./SaveAsTemplate";

export default function BroadcastSendDropdown({
  errors,
  update,
  sendList,
  broadcastUUID,
  values,
  showErrors = undefined,
}) {
  const location = useLocation();

  return (
    <Dropdown align="end" className="d-inline-block">
      <Dropdown.Toggle
        className="fw-bold  px-3 py-1  me-2 btn small border-dark rounded-pill  border-2 text-nowrap text-white bg-colored"
        id="dropdown-send-broadcast"
      >
        <SendIcon width={20} className="white" />
        <span className="p-2">SEND</span>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item
          as={Link}
          to="?action=send-test"
          state={location.state}
          onClick={(e) => {
            if (
              showErrors &&
              errors.filter((err) => err.type !== "Message recipients").length >
                0
            ) {
              e.preventDefault();
              showErrors("test");
            }
          }}
        >
          <SendIcon width={20} />
          <span className="p-2"> SEND TEST</span>
        </Dropdown.Item>
        <Dropdown.Item
          as={Link}
          to="?action=send-broadcast"
          state={location.state}
          onClick={(e) => {
            if (showErrors && errors.length > 0) {
              e.preventDefault();
              showErrors();
            }
          }}
        >
          <SendIcon width={20} />
          <span className="p-2"> SEND BROADCAST</span>
        </Dropdown.Item>
        <Dropdown.Item
          as={Link}
          to="?action=schedule-broadcast"
          state={location.state}
          onClick={(e) => {
            if (showErrors && errors.length > 0) {
              e.preventDefault();
              showErrors();
            }
          }}
        >
          <ScheduleIcon width={20} />
          <span className="p-2"> SCHEDULE BROADCAST</span>
        </Dropdown.Item>
        {broadcastUUID !== "new" ? (
          <>
            <Dropdown.Item as="button" onClick={update}>
              <TampleteIcon width={20} />
              <span className="p-2">UPDATE TEMPLATE</span>
            </Dropdown.Item>
            <Dropdown.Item as="span">
              <MyModal
                label={
                  <span type="button">
                    <SaveTampleteIcon width={20} />
                    <span className="p-2">DUPLICATE TEMPLATE</span>
                  </span>
                }
                heading="DUPLICATE TEMPLATE"
              >
                <SaveAsTemplateForm
                  key={values.Uuid}
                  sendList={sendList}
                  isDefaultSaveContacts
                />
              </MyModal>
            </Dropdown.Item>
          </>
        ) : (
          <Dropdown.Item as="span">
            <MyModal
              label={
                <span type="button">
                  <SaveTampleteIcon width={20} />
                  <span className="p-2">SAVE AS TEMPLATE</span>
                </span>
              }
              heading="SAVE AS TEMPLATE"
            >
              <SaveAsTemplateForm
                key={values.Uuid}
                sendList={sendList}
                isDefaultSaveContacts
              />
            </MyModal>
          </Dropdown.Item>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
}
